/* global $ */
import React from 'react';
import ReactDOM from 'react-dom';
import FormField from 'components/common/FormField';
import Button from 'components/common/Button';
import Payment from 'payment';

export default class BookingForm extends React.Component {
  componentDidMount() {
    const el = ReactDOM.findDOMNode(this);
    if (this.props.isCreditCard) {
      const cc = el.querySelector("#card-number");
      Payment.formatCardNumber(cc);

      const exp = el.querySelector("#valid-date");
      Payment.formatCardExpiry(exp);

      const cvc = el.querySelector("#cvc");
      Payment.formatCardCVC(cvc);
    }

    $("#phone", el).intlTelInput({
      utilsScript: 'https://unpkg.com/intl-tel-input@11.1.1/build/js/utils.js',
      autoPlaceholder: "off"
    });
  }

  onSubmit = this.onSubmit.bind(this);

  onSubmit(e) {
    const elements = e.target.elements;
    const data = {
      firstName: elements['first-name'].value,
      lastName: elements['last-name'].value,
      email: elements.email.value,
      phone: $(elements.phone).intlTelInput("getNumber"),
      message: elements.message.value
    };

    if (this.props.isCreditCard) {
      data['cardNumber'] = elements['card-number'].value;
      data['expiration'] = elements['valid-date'].value;
      data['cvc'] = elements['cvc'].value;
    }

    this.props.onSubmit(data);
    e.preventDefault();
  }


  render() {
    const { isCreditCard, booking, color } = this.props;
    const buttonStr = isCreditCard ? 'Book Now' : 'Request to Book';

    return (
      <form className="booking-form" onSubmit={this.onSubmit}>
        <h2>Billing details</h2>
        <div className="row no-gutters">
          <FormField className="col-md mr-md-25 mb-45 mb-md-25" id="first-name" label="First Name*" required={true}/>
          <FormField className="col-md mb-45 mb-md-25" id="last-name" label="Last Name*" required={true}/>
        </div>
        <div className="row no-gutters">
          <FormField className="col-md mr-md-25 mb-45 mb-md-25" id="email" label="Email*" required={true}/>
          <FormField className="col-md mb-45 mb-md-25" id="phone" label="Phone"/>
        </div>
        { isCreditCard && <div className="row no-gutters">
          <FormField className="col-md mr-md-25 mr-md-25 mb-45 mb-md-25 credit-card-field" id="card-number" label="Card number*" required={true}>
            <div className="credit-card-img"/>
          </FormField>
          <div className="col d-flex">
            <div className="mr-45 mr-md-25" style={{ flex: 1 }}>
              <FormField className="mb-45 mb-md-25" id="valid-date" label="Valid Date*" required={true}/>
            </div>
            <div style={{ flex: 1 }}>
              <FormField className="mb-45 mb-md-25" id="cvc" label="CVV*" required={true}/>
            </div>
          </div>
        </div> }
        <div className="row no-gutters">
          <FormField className="col mb-45 mb-md-25" id="message" label="Message" multiline={true} rows={isCreditCard ? 8 : 10}/>
        </div>
        <div className="row no-gutters">
          <Button size="lg" className="booking-btn submit-btn ml-md-auto" isDisabled={booking} style={{background: color}}>{buttonStr}</Button>
        </div>
      </form>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/BookingForm.js